import React from 'react';
import classnames from 'classnames';
import { Heading, Subtitle } from 'components/Text';
import Button from 'components/Button';

import styles from './Onboarding.module.scss';

type Props = {
  icon?: React.ReactNode,
  title: React.ReactChild,
  description: React.ReactChild,
  action?: React.ReactNode,
  button?: Partial<GetComponentProps<Button>>,
  onClick?: () => void,
  className?: string,
  children?: React.ReactNode,
  bottom?: React.ReactNode,
};

const OnboardingScreen: React.FC<Props> = ({
  title, description, action = null, onClick, className = '', children, bottom, button = {}, icon,
}: FunctionProps<Props>) => {
  const classes = classnames(styles.center, styles.width, 't-center', className);
  return (
    <div className={ classes }>
      { icon &&
        <div className={ styles.screenIcon }>
          { icon }
        </div>
      }
      <Heading type="large" className={ classnames('t-center', styles.screenTitle) }>
        { title }
      </Heading>
      <Subtitle color="dark-light" type="normal" className={ styles.screenDescription }>
        { description }
      </Subtitle>
      { children }
      { action !== null &&
        <Button
          size="large"
          className={ styles.screenButton }
          onClick={ onClick }
          { ...button }
        >
          { action }
        </Button>
      }
      { bottom }
    </div>
  );
};

export default OnboardingScreen;
